
export default function(){
    
    const initialState = {}

    return function(state = initialState, action) {

        switch(action.type){

            //
            default: return state

        }

    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/route-blocker/route-blocker-reducer.ts